import React from 'react'
import MainLayout from '../../../../components/layouts/MainLayout'
import NewDepositCoin from './NewDepositCoin'
import CardLayout from '../../../../components/layouts/CardLayout'
import { Text, useWindowSize } from '../../../../modules/Dashboard'
import { MOBILE_SIZE } from '../../../../core/constants/common'

const DepositCoinPage = () => {

    const { width } = useWindowSize()

    return (
        <MainLayout>
            <div className='max-w-lg mx-auto mt-5 md:mt-10 pb-10'>
                <div className='flex flex-col items-center gap-5 mb-10'>
                    {
                        width >= MOBILE_SIZE ?
                            <>
                                <Text tid={"charge-wallet"} className='text-5xl text-center' />
                                <Text tid={"charge-wallet-desc"} className='text-xl text-center' />
                            </> :
                            <div className='flex flex-col items-center gap-2'>
                                <Text tid={"increase-balance"} className='text-4xl text-center mx-auto' />
                            </div>
                    }
                </div>
                <CardLayout className="!px-4">
                    {/* Header Title */}
                    <div className="hidden md:block absolute -top-5 left-1/2 -translate-x-1/2 z-10">
                        <div className="bg-cardBgDark/50 rounded-lg py-1 px-10 relative">
                            <div className="absolute top-0 left-0 h-[1px] bg-gradient-to-r from-[#FC643200] via-[#FC6432] to-[#FC643200] w-full rounded-t-lg" />
                            <Text tid={"deposit-coin"} className="text-xl" />
                            <div className="absolute bottom-0 left-0 h-[1px] bg-gradient-to-r from-[#FC643200] via-[#FC6432] to-[#FC643200] w-full rounded-b-lg" />
                        </div>
                    </div>
                    <NewDepositCoin />
                </CardLayout>
            </div>
        </MainLayout>
    )
}

export default DepositCoinPage